var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cloud_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.74 10H18a5 5 0 1 1 0 10H9a8 8 0 1 1 7.74-10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};

export { SvgCloud as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTEwNl8xNzM0MCkiPjxwYXRoIGQ9Ik0xNi43NDAxIDEwSDE4LjAwMDFDMTkuMzI2MiAxMCAyMC41OTggMTAuNTI2OCAyMS41MzU2IDExLjQ2NDVDMjIuNDczMyAxMi40MDIxIDIzLjAwMDEgMTMuNjczOSAyMy4wMDAxIDE1QzIzLjAwMDEgMTYuMzI2MSAyMi40NzMzIDE3LjU5NzkgMjEuNTM1NiAxOC41MzU1QzIwLjU5OCAxOS40NzMyIDE5LjMyNjIgMjAgMTguMDAwMSAyMEg5LjAwMDExQzcuNTAzNTkgMjAuMDAxMSA2LjAzNjc2IDE5LjU4MjQgNC43NjYyOSAxOC43OTE2QzMuNDk1ODMgMTguMDAwNyAyLjQ3MjY3IDE2Ljg2OTMgMS44MTMwOSAxNS41MjZDMS4xNTM1IDE0LjE4MjYgMC44ODM5MzUgMTIuNjgxMiAxLjAzNTAyIDExLjE5MjRDMS4xODYxIDkuNzAzNDggMS43NTE3NyA4LjI4NjgzIDIuNjY3NzYgNy4xMDMzOEMzLjU4Mzc1IDUuOTE5OTMgNC44MTMzMiA1LjAxNzE0IDYuMjE2NzYgNC40OTc1OUM3LjYyMDIgMy45NzgwNCA5LjE0MTI0IDMuODYyNTYgMTAuNjA3IDQuMTY0MjhDMTIuMDcyOCA0LjQ2NTk5IDEzLjQyNDYgNS4xNzI4IDE0LjUwODggNi4yMDQ0QzE1LjU5MjkgNy4yMzU5OSAxNi4zNjYgOC41NTEgMTYuNzQwMSAxMFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzUxMDZfMTczNDAiPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";